<section class="form-step-view">
	<p class="form-step-view__question">{{ resolveStepText('step_name') }}</p>

	<div class="form-step-view__fields">
		@for (field of fieldsArray.controls; track $index; let i = $index) {
			<div class="form-step-view__field">
				<tec-form-group [label]="resolveFieldLabel(i)">
					<tec-input [value]="''" [disabled]="true" />
				</tec-form-group>
			</div>
		}
	</div>
</section>
